import PreferitiNotifications from "./PreferitiNotifications.tsx";

export const preferiti = () => [
  {
    target: "$ONE_TOOLBAR_CONTENT_RIGHT",
    handler: {
      component: PreferitiNotifications,
      props: { drawerName: "preferitiDrawer" },
    },
  },
];
